import Lottie from 'react-lottie';
import * as SC from './styled';

interface IImageArea {
  image?: string;
  animation?: string;
}

const ImageArea = ({ image, animation }: IImageArea) => {
  if (image) {
    return (
      <SC.MockImage>
        <img src={image} alt="" />
      </SC.MockImage>
    );
  }
  if (animation) {
    return (
      <SC.LottieContainer>
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData: animation,
          }}
          isClickToPauseDisabled={true}
          speed={0.5}
          height={250}
          width={250}
        />
      </SC.LottieContainer>
    );
  }
  return <></>;
};

export default ImageArea;
